const LABEL_RELATIONSHIP = 'labels';
const CUSTOM_ATTRIBUTE_RELATIONSHIP = 'customAttributes';
const TEAM_MEMBER_RELATIONSHIP = 'selectedTeamMember';

export default function (selectedTeam, selectedLabel, selectedTeamMember, customAttributes) {
    const filters = [];

    if (selectedTeam !== null && selectedTeamMember !== null) {
        filters.push({
            type: TEAM_MEMBER_RELATIONSHIP,
            value: selectedTeamMember,
        });
    }

    if (selectedLabel !== null) {
        filters.push({
            type: LABEL_RELATIONSHIP,
            value: selectedLabel,
        });

        for (const customAttribute of customAttributes) {
            if (customAttribute.selected !== null) {
                filters.push({
                    type: CUSTOM_ATTRIBUTE_RELATIONSHIP,
                    id: customAttribute.id,
                    value: customAttribute.selected,
                });
            }
        }
    }

    return filters;
}
